import { fetch } from '../utils/fetch'

/*
    API:    GET
    NAME:   获取账本
*/
export function getAccountBook() {
  return fetch({
    url: 'subarea/queryList',
    method: 'get'
  })
}

/*
    API:    GET
    NAME:   获取当前我的账本
*/
export function getMyListBook() {
  return fetch({
    url: 'subarea/queryMyList',
    method: 'get'
  })
}

/*
    API:    GET
    NAME:   获取账本详情
*/
export function getAccountBookInfo(id) {
  return fetch({
    url: `subarea/view/${id}`,
    method: 'get'
  })
}

/*
    API:    POST
    NAME:   新增账本
*/
export function addAccountBookInfo(data) {
  return fetch({
    url: `subarea/save`,
    method: 'post',
    data: data
  })
}
/*
      API:    POST
      NAME:   编辑账本
  */
export function updateAccountBookInfo(data) {
  return fetch({
    url: `subarea/update`,
    method: 'post',
    data: data
  })
}

/*
  API:    POST
  NAME:   删除账本
  */
export function deleteAccountBook(id) {
  return fetch({
    url: `subarea/delete/${id}`,
    method: 'POST'
  })
}

